export default __webpack_public_path__ + "static/media/36I-103555_-17651_0.2b4ffc8b.jpg";